import { ConfigStateService } from '@abp/ng.core';
import { Injector, LOCALE_ID } from '@angular/core';

export const LOCALIZATION__CURRENT_CULTURE__TWO_LETTER_ISO_LANGUAGE_NAME =
  'localization.currentCulture.twoLetterIsoLanguageName';

export function provideDecimalPipe() {
  return {
    provide: LOCALE_ID,
    deps: [Injector],
    useFactory: DwDecimalPipeFactory,
  };
}

export function DwDecimalPipeFactory(injector: Injector) {
  const lang = injector
    .get(ConfigStateService)
    .getDeep(LOCALIZATION__CURRENT_CULTURE__TWO_LETTER_ISO_LANGUAGE_NAME);
  if (lang == null || lang === '') {
    console.warn(
      'DwDecimalPipeFactory: No language found in ConfigStateService, defaulting to "fr-BE"',
    );
    return 'fr'; // Default to a common locale if none is found
  }
  return lang;
}
